import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker'
import { CommonComponentsModule } from 'src/app/common-components/common-components.module'
import { SharedModule } from 'src/app/shared/shared.module'
import { ProductModule } from '../product/product.module'
import { TranslationModule } from '../translation/translation.module'
import { CourseBookingTabComponent } from './course-booking-tab/show.component'
import { CourseRoutingModule } from './course-routing.module'
import { CourseEffects } from './course.effects'
import * as fromCourse from './course.reducer'
import { CourseSerializer } from './course.serializer'
import { CourseService } from './course.service'
import { CourseCreateComponent } from './create/show.component'
import { CourseFormComponent } from './form-general/form-general.component'
import { CourseGeneralTabComponent } from './general-tab/show.component'
import { DuplicatedCoursesModalComponent } from './index/duplicated-courses-modal/duplicated-courses-modal.component'
import { CourseIndexComponent } from './index/index.component'
import { CourseTableComponent } from './table/table.component'
import { CourseParticipationTabComponent } from './participation-tab/show.component'
import { CourseShowComponent } from './show/show.component'
import { BookingModule } from '../booking/booking.module'
import { CourseBookingCreateTabComponent } from './course-create-bookings-tab/show.component'
import { CreateCourseSaleModalComponent } from './create-course-sale-modal/show.component'
import { RaffleInvitePersonComponent } from './raffle-invite-person-modal/show.component'
import { RaffleModule } from '../raffle/raffle.module'
import { CommunicationBlockModule } from 'src/app/shared/components/communication-block/communication-block.module'
import { CourseCommunicationTabComponent } from './communication-tab/communication-tab.component'
import { CourseActivitiesMainTabComponent } from './course-activities-tab/course-activities-tab.component'
import { ActivityModule } from '../activity/activity.module'
import { EmailLogModule } from '../email-log/email-log.module'
import { activitiesBlockModule } from 'src/app/shared/components/activities-block/activities-block.module'
import { CourseAchievementTabComponent } from './course-achievement-tab/show.component'
import { AchievementTableComponent } from 'src/app/shared/components/achievement-table/table.component'
import { AdjustAchievementAnswersModalComponent } from './course-achievement-tab/adjust-answers-modal.component'
import { ParticipantBookingsModalComponent } from './participation-tab/participant-bookings-modal.component'

@NgModule({
  imports: [
    CommonModule,
    CommonComponentsModule,
    CourseRoutingModule,
    SharedModule,
    ProductModule,
    BookingModule,
    StoreModule.forFeature(fromCourse.FEATURE_NAME, fromCourse.courseReducer),
    EffectsModule.forFeature([CourseEffects]),
    TranslationModule,
    NzDatePickerModule,
    RaffleModule,
    CommunicationBlockModule,
    ActivityModule,
    EmailLogModule,
    activitiesBlockModule
  ],
  declarations: [
    CourseActivitiesMainTabComponent,
    DuplicatedCoursesModalComponent,
    CourseParticipationTabComponent,
    CourseIndexComponent,
    CourseTableComponent,
    CourseShowComponent,
    CourseGeneralTabComponent,
    CourseBookingTabComponent,
    CourseFormComponent,
    CourseCreateComponent,
    CourseBookingCreateTabComponent,
    CreateCourseSaleModalComponent,
    RaffleInvitePersonComponent,
    CourseCommunicationTabComponent,
    CourseAchievementTabComponent,
    AchievementTableComponent,
    AdjustAchievementAnswersModalComponent,
    ParticipantBookingsModalComponent
  ],
  exports: [],
  providers: [
    CourseService,
    {
      provide: CourseSerializer,
      useClass: CourseSerializer
    }
  ]
})
export class CourseModule {}
